import { getActiveChild, getParent, getSignedInData } from '../atomstore/serviceAtoms';

function normalizeParentType(value) {
    if (!value) return undefined;
    const v = String(value).toLowerCase();
    if (v === 'mother' || v === 'father') return v;
    if (v.includes('mother')) return 'mother';
    if (v.includes('father')) return 'father';
    return String(value).slice(0, 20);
}

/** Child / center / parent from activeChildDetail + parentProfile atoms. */
export function getActiveEventContext() {
    const activeChild = getActiveChild();
    const parentProfile = getParent();

    const parentType = normalizeParentType(
        parentProfile?.parentType ?? activeChild?.parent
    );

    return {
        childId: activeChild?.id != null ? String(activeChild.id) : undefined,
        centerId: activeChild?.center_id != null
            ? String(activeChild.center_id)
            : activeChild?.center != null
                ? String(activeChild.center)
                : undefined,
        centerName:
            activeChild?.['admission_center_name.name'] ||
            activeChild?.centerName ||
            undefined,
        parentType,
    };
}

/** Email or phone from Login_Form — only meaningful during the login flow. */
export function getLoginEventContext() {
    const form = getSignedInData();
    if (!form) return {};

    const phone = String(form.phone || '').trim();
    const email = String(form.email || '').trim().toLowerCase();

    if (phone) {
        return { loginContact: phone, loginMethod: 'phone' };
    }
    if (email) {
        return { loginContact: email, loginMethod: 'email' };
    }
    return {};
}
